<div class="title-bar title-bar--responsive">
  <div class="title-bar__heading">
    <h1>COSTS</h1>
    <app-help screen="costs"></app-help>
  </div>
  <div class="title-bar__actions">
    @if (!editMode) {
      <button mat-flat-button color="primary" (click)="setMode('edit')">Edit Costs</button>
    }
    @if (editMode) {
      <button mat-flat-button color="accent" (click)="setMode('save')">Save Costs</button>
      <button mat-flat-button color="warn" (click)="setMode('cancel')">Cancel</button>
    }
    <app-aid-year [disabled]="editMode"></app-aid-year>
  </div>
</div>

@if (editMode) {
  <div class="rounding-message">
    <p>In order to allow families to budget and plan for college, consider <strong>using round numbers</strong> to display a rough estimate for families.</p>
  </div>
}

@if (cc.expenses | async; as expenses) {
  <div>
    <mat-card appearance="outlined">
      <div class="costs-table-wrapper">
        <table class="table table-hover" style="width: auto">
          <thead>
            <tr>
              <th scope="col" id="costs-expense-header">Expense</th>
              <th scope="col" id="costs-population-header">Population</th>
              <th scope="col" id="costs-amount-header">Amount</th>
              @if (editMode) {
                <th scope="col" class="text-center" id="costs-action-header">Action</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (exp of expenses; track exp) {
              @for (r of exp.rules; track r; let i = $index) {
                @if (!editMode) {
                  <tr class="costs-row" [class.costs-row--linked]="!!r.tableId">
                    @if (i === 0) {
                      <th [attr.scope]="exp.rules.length > 1 ? 'rowgroup' : 'row'" [attr.rowspan]="exp.rules.length" [attr.id]="getExpenseHeaderId(exp)">
                        {{ expenseNameMap[exp.type] }}
                      </th>
                    }
                    <td>
                      {{ r.populationId === "1" ? "All" : "" }}
                      @if (r.population; as pop) {
                        <div>
                          {{ pop.name }} <br /><span class="description">{{ pop.description }}</span>
                        </div>
                      }
                    </td>
                    <td>
                      @if (!r.tableId) {
                        <span>{{ r.amount | number }}</span>
                      }
                      @if (r.tableId) {
                        <a class="link" [routerLink]="['/', schoolId, 'tables', r.table?.tableId || r.tableId]" [queryParams]="{ from: 'costs' }" [state]="{ from: 'costs' }" [attr.aria-label]="'View table ' + (r.table?.name || 'details')">
                          {{ r.table?.name }}
                        </a>
                      }
                    </td>
                  </tr>
                }
                <!-- Edit Rules -->
                @if (editMode) {
                  <tr>
                    <td>
                      @if (i === 0) {
                        <span [id]="getExpenseHeaderId(exp)">{{ expenseNameMap[exp.type] }}</span>
                      }
                      <!-- <div *ngIf="r.tableId"><button mat-button (click)="r.tableId = null">use amount</button></div>
                      <div *ngIf="!r.tableId"><button mat-button (click)="r.tableId = r.table?.tableId || '1'">use table</button></div> -->
                      <div style="font-size: 10pt; margin-top: 0.5rem">
                        <mat-radio-group [(ngModel)]="r.tableId" role="radiogroup" [attr.aria-labelledby]="expenseNameMap[exp.type]">
                          <mat-radio-button aria-label="Use Amount" [value]="null" class="radio-option" style="margin-right: 1rem">Use Amount</mat-radio-button>
                          <mat-radio-button aria-label="Use Table" [value]="r.table?.tableId || r.tableId || '1'" class="radio-option">Use Table</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </td>
                    <td>
                      <mat-form-field class="population-select">
                        <mat-label>Select Population</mat-label>
                        <mat-select placeholder="Select Population" [(value)]="r.populationId" (selectionChange)="setRulePopulation(r)" [attr.aria-labelledby]="getFieldLabelIds('population', exp)">
                          <mat-option value="1" id="All">All</mat-option>
                          @for (pop of cc.populations | async; track pop) {
                            <mat-option [value]="pop.id">
                              {{ pop.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      @if (r.population; as pop) {
                        <div>{{ pop.description }}</div>
                      }
                    </td>
                    <td>
                      @if (!r.tableId) {
                        <div>
                          <mat-form-field style="width: 5em">
                            <mat-label>Amount</mat-label>
                            <input matInput placeholder="Amount" type="number" [(ngModel)]="r.amount" [attr.aria-labelledby]="getFieldLabelIds('amount', exp)" />
                          </mat-form-field>
                        </div>
                      }
                      @if (r.tableId) {
                        <div>
                          <mat-form-field class="form-field">
                            <mat-label>Select Table</mat-label>
                            <mat-select placeholder="Select Table" [(value)]="r.tableId" (selectionChange)="setRuleTable(r)" [attr.aria-labelledby]="getFieldLabelIds('table', exp)">
                              @for (table of cc.tables | async; track table) {
                                <mat-option [value]="table.tableId">
                                  {{ table.name }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                      }
                    </td>
                    <td class="costs-action-cell">
                      <button mat-button color="warn" (click)="deleteRule(exp, i)">delete rule</button>
                      @if (i === exp.rules.length - 1) {
                        <button mat-button color="secondary" (click)="addRule(exp)">add rule</button>
                      }
                    </td>
                  </tr>
                }
              }
            }
          </tbody>
        </table>
      </div>
    </mat-card>
  </div>
}
